import React from 'react';
import { Link } from 'react-router-dom';
import {
  makeStyles,
  ListItem,
  ListItemIcon,
  ListItemText,
  Badge,
  Tooltip
} from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles({
  icon: {
    minWidth: '40px'
  },
  listItemText: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gridGap: 8,
    fontSize: '13px'
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 100
  },
  badge: {
    '& svg': {
      height: 24,
      width: 24
    }
  }
}, { name: 'DrawerItem' });

const DrawerListItem = ({
  open,
  icon,
  text,
  to,
  badgeProps
}) => {
  const classes = useStyles();

  return (
    <Tooltip
      title={ text }
      disableHoverListener={ open }
      disableFocusListener={ open }
      disableTouchListener={ open }
    >
      <ListItem button key={ 2 } component={ Link } to={ to }>
        <ListItemIcon className={ classes.icon }>
          <Badge
            invisible={ open || !badgeProps.badgeContent }
            { ...badgeProps }
            className={ clsx(classes.badge, badgeProps.className) }
            overlap="rectangular"
          >
            {icon}
          </Badge>
        </ListItemIcon>
        <ListItemText
          classes={ { primary: classes.listItemText } }
          primary={
            <>
              <span className={ classes.text }>{text}</span>
              <span>{badgeProps.badgeContent}</span>
            </>
          }
        />
      </ListItem>
    </Tooltip>
  );
};

export default DrawerListItem;